import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Envelope } from "@phosphor-icons/react";
import api, { formatErr } from "@/lib/api";
import ThemeToggle from "@/components/layout/ThemeToggle";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    api.get("/config").then(({ data }) => setEnabled(!!data.password_reset_enabled)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e) {
      setErr(formatErr(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-app-bg text-app-text p-4 relative">
      <div className="absolute top-3 right-3"><ThemeToggle compact /></div>
      <div className="w-full max-w-sm">
        <Link to="/login" className="inline-flex items-center gap-1.5 font-mono-d text-[10px] uppercase tracking-widest text-app-subtle hover:text-app-text mb-6">
          <ArrowLeft size={12} /> Back to sign in
        </Link>

        <div className="font-mono-d text-[10px] uppercase tracking-[0.3em] text-app-subtle mb-2">Account recovery</div>
        <h1 className="font-display font-black text-2xl tracking-tight mb-6">Reset password</h1>

        {!enabled && (
          <div className="mb-4 px-3 py-2 border border-[#FF9500]/30 text-[#FF9500] text-xs font-mono-d">
            Password reset is not configured. Contact your administrator.
          </div>
        )}

        {done ? (
          <div className="px-3 py-3 border border-[#10B981]/30 text-[#10B981] text-sm" data-testid="reset-sent">
            If that email exists, a reset link has been sent. Check your inbox.
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <div className="mb-4">
              <label className="block font-mono-d text-[10px] uppercase tracking-widest text-app-subtle mb-2">Email</label>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={!enabled}
                className="w-full bg-app-surface border border-app-border px-3 py-3 text-sm focus:outline-none focus:border-[#007AFF] min-h-[44px] disabled:opacity-50"
              />
            </div>
            {err && <div className="mb-4 px-3 py-2 bg-[#FF3B30]/10 border border-[#FF3B30]/30 text-[#FF6B61] text-xs">{err}</div>}
            <button
              type="submit"
              disabled={loading || !enabled}
              className="btn-touch w-full bg-[#007AFF] hover:bg-[#3395FF] disabled:opacity-50 text-white py-3 text-sm font-semibold flex items-center justify-center gap-2"
            >
              <Envelope size={14} />
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
